import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';

import { getCurrentSiteId } from '../../site/selectors';

import {
  ACTION_LOAD_SITE_GOOGLE_TOOL__REQUEST,
  ACTION_LOAD_SITE_GOOGLE_TOOL__SUCCESS,
  ACTION_LOAD_SITE_GOOGLE_TOOL__FAIL,
} from '../actionTypes';


export const actionLoadSiteGoogleToolSuccess = siteGoogleTool => ({
  type: ACTION_LOAD_SITE_GOOGLE_TOOL__SUCCESS,
  payload: { siteGoogleTool },
});

export const actionLoadSiteGoogleToolFail = error => ({
  type: ACTION_LOAD_SITE_GOOGLE_TOOL__FAIL,
  payload: { error },
});

export const actionLoadSiteGoogleToolRequest = () => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_LOAD_SITE_GOOGLE_TOOL__REQUEST,
    });

    return apiClientHelper.get(
      `/rest/webmaster/google_tool/${getCurrentSiteId(getState())}`
    ).then(
      siteGoogleTool => {
        dispatch(actionLoadSiteGoogleToolSuccess(siteGoogleTool));
      },
      error => {
        dispatch(actionLoadSiteGoogleToolFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);
